<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider="chevron_right">
          <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br>

    <!-- MODAL AJOUT DES VISITES DE CHANTIER -->
    <v-dialog v-model="dialogValid" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Ajouter une nouvelle visite de chantier </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogValid = false;" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formVisite" lazy-validation id="formVisite">
            <v-container fluid grid-list-md>
              <p align="center">
                <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                  Détails de la visite de chantier  <v-icon right>terrain</v-icon>
                </v-chip>
              </p>

              <v-layout row>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Objet de la visite</span>
                    <el-input v-model="objet" name="objet"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Projet concerné</span>
                    <el-select @change="loadProjChantier" filterable v-model="selectProjet" placeholder="Le projet" style="width:100%">
                      <el-option v-for="item in listProjet" :key="item.id" :label="item.libelle" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>

                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Chantier concerné </span>
                    <el-select filterable v-model="selectChantier" placeholder="Le chantier" style="width:100%">
                      <el-option v-for="item in listChantier" :key="item.id" :label="item.libelle" :value="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Date de visite</span>
                    <el-date-picker :disabled="disabledBtnStat"  v-model="dateVisite" name="dateVisite" id="dateVisite" value-format="dd-MM-yyyy" type="date" placeholder="Date de le visite" style="width: 100%"></el-date-picker>
                  </div>
                </v-flex>

                <!-- <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Statut </span>
                    <el-select :disabled="disabledBtn" filterable v-model="selectStatut" placeholder="Etat de la visite" style="width:100%">
                      <el-option v-for="item in statut" :key="item.etat" :label="item.label" :value="item.etat">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex> -->
              </v-layout>

              <v-layout row>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Nom du controleur</span>
                    <el-input v-model="nomControleur"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <br>
              <v-btn @click="dialogValid = false" color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>
              <v-btn icons @click="submitVisite" color="blue" dark>Ajouter <v-icon right>add</v-icon></v-btn>

            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW VISITE -->
    <v-dialog v-model="dialogShowVisite" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue darken-2">
          <v-toolbar-title>Détails de la visite </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowVisite = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-card class="box-card">
                  <div class="grid-content" style="padding:3px;">
                    <el-row>
                      <div class="text item">

                        <v-layout row justify>
                          <p><b>Objet de la visite : </b> {{ visiteCourant.objet }} </p>
                        </v-layout>
                        <v-layout row justify>
                          <v-flex md6>
                            <p><b>Projet concerné : {{ visiteCourant.projet }} </b> </p> 
                            <p><b>Chantier concerné : </b> {{ visiteCourant.chantier }} </p>
                            <p><b>Controleur : </b> {{ visiteCourant.controleur }} </p>
                          </v-flex>
                          <v-flex md6>
                            <p><b>Date d'enregistrement : </b> {{ visiteCourant.created }} </p>
                            <p><b>Date de la visite : </b> {{ visiteCourant.dateVisite }} </p>
                            <p><b>Statut : </b>
                              <v-chip v-if="visiteCourant.statut == 0" label text-color="white" color="green">
                                EN ATTENTE
                              </v-chip>
                              <v-chip v-if="visiteCourant.statut == 1" label text-color="white" color="red">
                                TERMINEE
                              </v-chip>   
                            </p>
                          </v-flex>
                        </v-layout>
                        <v-layout v-if="visiteCourant.statut == 1" row justify>
                          <p><b>Description du rapport : </b> {{ visiteCourant.description }} </p>
                        </v-layout>

                        <h6 v-if="visiteCourant.statut == 1"> Taches concernees </h6>
                        <v-layout v-if="visiteCourant.statut == 1" row justify>
                          <p v-for="(item, index) in visiteCourant.tache">
                              {{ item.tacheId }} - {{ item.tacheLib }}
                          </p>
                        </v-layout>
                      </div>
                    </el-row>
                  </div>
                </el-card>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" @click.stop="dialogShowVisite = false" icons color="orange" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL RAPPORT DE CHANTIER -->
    <v-dialog v-model="dialogRapportValid" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title>
            <span>Ajouter un rapport de visite de chantier </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogRapportValid = false;" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form v-model="valid" ref="formRapport" lazy-validation id="formRapport">
            <v-container fluid grid-list-md>
              <p>
                <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                  Rapport sur le chantier {{ visiteCourant.chantier }}  <v-icon right>terrain</v-icon>
                </v-chip>
              </p>

              <el-row>
                <div class="text item">
                  <v-layout row justify>
                    <p><b>OBJET DE LA VISITE: </b> {{ visiteCourant.objet }} </p>
                  </v-layout>
                  <v-layout row justify>
                    <v-flex md6>
                      <p><b>PROJET CONCERNE: {{ visiteCourant.projet }} </b> </p> 
                      <p><b>CHANTIER CONCERNE: </b> {{ visiteCourant.chantier }} </p>
                      <p><b>CONTROLEUR : </b> {{ visiteCourant.controleur }} </p>
                    </v-flex>
                    <v-flex md6>
                      <p><b>DATE D'ENREGISTREMENT: </b> {{ visiteCourant.created }} </p>
                      <p><b>DATE D'ENREGISTREMENT: </b> {{ visiteCourant.dateVisite }} </p>
                    </v-flex>
                  </v-layout>
                  <v-layout row justify>
                    <p><b>LISTE DES TRAVAUX </b> </p>
                  </v-layout>
                </div>
              </el-row>

              <v-layout row>
                <v-flex md12>
                  <el-table
                      ref="multipleTable"
                      :data="listTravaux"
                      style="width: 100%"
                      @selection-change="handleSelectionChange">

                      <el-table-column
                        type="selection"
                        width="55">
                      </el-table-column>
                      <el-table-column
                        label="Date de travaux"
                        width="120">
                        <template slot-scope="scope">{{ scope.row.dateDtravo }}</template>
                      </el-table-column>
                      <el-table-column
                        label="Travaux"
                        width="120">
                        <template slot-scope="scope">{{ scope.row.labelTravo }}</template>
                      </el-table-column>
                      <el-table-column
                        label="Tache"
                        width="120">
                        <template slot-scope="scope">{{ scope.row.labelTache }}</template>
                      </el-table-column>
                      <el-table-column
                        property="typeTravaux"
                        label="Type de tache"
                        show-overflow-tooltip>
                      </el-table-column>
                  </el-table>
                  <br/>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex md12>
                  <div class="block">
                    <span class="demonstration">Description de la visite</span>
                    <el-input type="textarea" v-model="rapportField" name="rapport" placeholder="Ecrivez votre rapport ici" style="width:100%" required></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <br>
              <v-btn @click="dialogRapportValid = false" color="orange" dark>Annuler <v-icon right>close</v-icon></v-btn>
              <v-btn icons @click="submitRapport" color="blue" dark>Ajouter <v-icon right>add</v-icon></v-btn>

            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION VISITE-->
    <v-dialog v-model="dialogSupVisite" width="50%" :overlay="true" scrollable persistent>
          <v-card>
            <v-card-title class="text-xs-center">
                <h3 class="headline mb-0">Supprimer la visite</h3>
                  <v-flex xs12>
                    <v-alert outline color="orange darken-1" icon="warning" :value="true">
                        La suppression d'une visite est irréversible.
                    </v-alert>
                  </v-flex>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click.stop="dialogSupVisite = false">Annuler</v-btn>
              <v-btn icons color="red" @click.stop="deleteVisite()" dark>Supprimer </v-btn>
            </v-card-actions>
          </v-card>
    </v-dialog>

    <!-- TABLEAU -->
    <v-card>
      <div>
        <v-chip text-color="white" label color="primary">
          LISTE DES VISITES DE CHANTIER <v-icon right>terrain</v-icon>
        </v-chip>
        <v-flex xs3 >
          <el-col :span="2" >
            <el-popover
            ref="popover5"
            placement="top"
            width="180"
            trigger="hover"
            >
              <p>Veuillez choisir le format d'impression ?</p>
              <div style="text-align: right; margin: 0">
                <el-button type="success" size="mini" @click="imprimeListeVisite('PDF')">PDF</el-button>
                <el-button type="primary" size="mini" @click="imprimeListeVisite('EXC')">EXCEL</el-button>
              </div>
            </el-popover>
              <div>
                <el-button v-popover:popover5 type="warning"
                    icon="el-icon-printer" >Imprimer la liste
                </el-button>
              </div>
          </el-col>
        </v-flex>

        <!-- BTN AJOUT -->
        <v-spacer></v-spacer>
        <div class="text-xs-right">
          <v-tooltip top>
            <v-btn slot="activator" icons color="primary" @click="newVisiteChantier" dark>Ajouter <v-icon right>add</v-icon></v-btn>
            Ajouter un nouvelle visite
          </v-tooltip>
        </div>

        <v-card-text>
          <data-tables :data="listVisiteChantier" style="width: 100%">
            <el-table-column prop="objet" label="OBJET" width="370" fixed="left">
              <template slot-scope="scope">
                <v-chip text-color="white" label color="primary">
                  {{scope.row.objet}}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="controleur" label="CONTROLEUR">
              <template slot-scope="scope">
                  {{scope.row.controleur}}
              </template>
            </el-table-column>
            <el-table-column prop="chantier" label="CHANTIER">
              <template slot-scope="scope">
                  {{ scope.row.chantier }}
              </template>
            </el-table-column>
            <el-table-column label="STATUT">
              <template slot-scope="scope">
                <v-chip v-if="scope.row.statut == 0" label text-color="white" color="green">
                    EN ATTENTE
                </v-chip>
                <v-chip v-if="scope.row.statut == 1" label text-color="white" color="red">
                    TERMINEE
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="created" label="DATE DE CREATION">
              <template slot-scope="scope">
                <v-chip text-color="white" color="orange">
                  {{scope.row.created}}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column label="Action" fixed="right">
              <template slot-scope="scope">
                <div class="text-xs-center">
                  <v-tooltip top>
                    <v-btn slot="activator" @click.stop="modalShowVisite(scope.row)" fab dark small color="green">
                      <v-icon dark>folder_open</v-icon>
                    </v-btn>
                    Détails
                  </v-tooltip>
                  <v-tooltip top v-if="scope.row.statut == 0">
                    <v-btn slot="activator" @click.stop="editVisiteChantier(scope.row)" fab dark small color="blue">
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                    Modifier
                  </v-tooltip>
                  <v-tooltip top v-if="scope.row.statut == 0">
                    <v-btn slot="activator" @click.stop="rapportVisiteChantier(scope.row)" fab dark small color="purple">
                      <v-icon dark>chat</v-icon>
                    </v-btn>
                    Rapport
                  </v-tooltip>
                  <v-tooltip top v-if="scope.row.statut == 1">
                    <v-btn v-popover:popover5 slot="activator" @click.stop="imprimerVisiteChantier(scope.row)" fab dark small color="orange">
                      <v-icon dark>print</v-icon>
                    </v-btn>
                    Imprimer
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn slot="activator" v-if="scope.row.statut == 0" @click.stop="modalDeleteVisite(scope.row)" fab dark small color="red">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                    Supprimer
                  </v-tooltip>
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </v-card-text>
      </div>
    </v-card>

  </div>
</template>

<script>
    var echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')
    require('echarts/lib/chart/funnel')
    require('echarts/lib/chart/sankey')
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')

    import Loading from '@/components/Loading';
    import ProjetMap from "@/components/map/ProjetMap";
    import  'dhtmlx-gantt';

    export default {
        components:{ Loading, ProjetMap},
        name: 'app',
        data () {
            return {
                notif: JSON.parse(sessionStorage.getItem('sessionNotif')),
                domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
                user: JSON.parse(sessionStorage.getItem('userInfo')),
                roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
                racourcis: [
                    { path: '/', text: 'Accueil', disabled: false },
                    { path: '/chantier', text: 'Liste des visites de chantier', disabled: true }
                ],
                loading:false,
                valid: true,
                listVisiteChantier: [],
                visiteCourant: [],
                listProjet: [],
                listChantier: [],
                listTravaux: [],
                tachesList: [],
                selectProjet: '',
                selectChantier: '',
                selectStatut: '',
                rapportField: '',
                disabledBtnSCTach: false,
                disabledBtn: true,
                dialogValid: false,
                dialogRapportValid: false,
                dialogShowVisite: false,
                dialogEdit: false,
                disabledBtnStat: false,
                dialogSupVisite: false,
                dateVisite: '',
                nomControleur: '',
                objet: '',
                dateNow: '',
                statut: [
                    {
                        etat:'0',
                        label:"En attente"
                    },
                    {
                        etat:'1',
                        label:"Terminée"
                    },
                ],
                multipleSelection: [],


                invoice_products: [{
                    product_no: '',
                    product_name: '',
                    product_price: '',
                    product_qty: '',
                    line_total: 0
                }],


            }
        },
        mounted () {
            this.loadPage()
            this.loadUser()
            this.loadVisiteChantier()
            this.loadProjet()
        },
        methods: {

            loadPage () {
              this.loading =  true
              var today = new Date();
              var dd = today.getDate();
              var mm = today.getMonth()+1; //January is 0!
              var yyyy = today.getFullYear();
              if(dd<10){
                  dd='0'+dd;
              } 
              if(mm<10){
                  mm='0'+mm;
              } 
              this.dateNow = dd+'/'+mm+'/'+yyyy;
            },
            loadUser () {
                this.loading =  true
                let url = this.domaine + 'userCreate/user-list'
                this.$http.get(url).then(response => {
                    if (response.body) {
                        this.users = response.body
                        this.loading =  false
                    }
                })
            },
            loadVisiteChantier () {
              this.loading =  true
              let url = this.domaine + 'visitechantier/index'
              this.loading = true
              this.$http.get(url).then(response => {
                  if (response.body) {
                      this.listVisiteChantier = response.body.visiteChantier
                      if (this.listVisiteChantier === undefined || this.listVisiteChantier.length == 0) {
                          this.disabledBtnSCTach = true
                      } else{
                        this.disabledBtnSCTach = false
                      }
                      this.loading = false
                  }
              })
            },
            loadProjet () {
              this.loading =  true
              let url = this.domaine + 'projet/index'
              this.loading = true
              this.$http.get(url).then(response => {
                  if (response.body) {
                      this.listProjet = response.body.projet
                      this.loading = false
                  }
              })
            },
            loadProjChantier () {
              this.selectChantier = ''
              let url = this.domaine + 'chantier/liste/'+ this.selectProjet +'/projet'
              this.loading = true
              this.$http.get(url).then(response => {
                  if (response.body) {
                      this.listChantier = response.body.chantier
                      this.loading = false
                  }
              })
            },
            submitVisite () {
              this.loading = true
              if (this.selectProjet != '' && this.selectChantier != '' && this.nomControleur != '' && this.dateVisite != '' && this.objet != '' && this.selectStatut != '' && (this.dateVisite > this.dateNow) ) {
                var form = document.getElementById('formVisite')
                var data = new FormData(form)
                let url = ''
                data.append('idProjet', this.selectProjet)
                data.append('idChantier', this.selectChantier)
                // data.append('statut', this.selectStatut)
                data.append('nomControleur', this.nomControleur)

                if (this.visiteCourant.id != '' ) {
                    url = this.domaine + 'visitechantier/'+ this.visiteCourant.id +'/'+ this.selectProjet +'/'+ this.selectChantier + '/edit'
                } else {
                    url = this.domaine + 'visitechantier/' + this.selectProjet +'/'+ this.selectChantier + '/new'
                }

                this.$http.post(url, data).then(response => {
                  if (response.body) {
                    let verif = response.body
                    console.log(verif)
                    if (verif.code === 1) {
                      this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: 'Visite de chantier enregistrée avec succès.',
                        type: 'success',
                        position: 'top-center'
                      })
                      this.loadVisiteChantier()
                      this.loading = false
                      this.dialogValid = false
                    } else if (verif.code === 0) {
                      this.$message.error(verif.message)
                      this.loading = false
                      this.dialogValid = false
                    }
                  } else {
                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                    this.loading = false
                    this.dialogValid = false
                  }
                },
                response => {
                  this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                  this.loading = false
                })
              } else {
                this.$message.error('Veuillez renseigner les champs obligatoires')
                this.$notify.error({
                  title: "ERREUR D'ENREGISTREMENT",
                  message: "La visite n'a pas été enregistrée.",
                  position: 'top-center'
                })
                this.loading = false
              } 
            },
            newVisiteChantier () {
                this.dialogValid = true
                this.dialogEdit = false
                this.visiteCourant.id = ''
                this.dateVisite = ''
                this.selectProjet = ''
                this.selectChantier = ''
                this.selectStatut = '0'
                this.objet = ''
                this.nomControleur = ''
            },
            editVisiteChantier (ligne) {
              this.dialogValid = true
              this.dialogEdit = true
              this.visiteCourant = ligne
              this.selectProjet = ligne.idprojet
              this.loadProjChantier ()
              this.selectChantier = ligne.idchantier
              this.selectStatut = ligne.statut
              if (ligne.statut === '1') {
                  this.disabledBtnStat = true
              } else{
                this.disabledBtnStat = false
              }
              this.objet = ligne.objet
              this.nomControleur = ligne.controleur
              this.dateVisite = ligne.dateVisite
            },
            rapportVisiteChantier (ligne) {
              this.rapportField = ''
              this.dialogRapportValid = true
              this.visiteCourant = ligne
              let url = this.domaine + 'visitechantier/load/'+ ligne.idchantier +'/list-travaux'
              this.loading = true
              this.$http.get(url).then(response => {
                  if (response.body) {
                      this.listTravaux = ''
                      this.listTravaux = response.body.listeTache
                      this.loading = false
                  }
              })
              
              console.log(this.dateNow)

            },
            modalShowVisite (item) {
                this.dialogShowVisite = true
                this.visiteCourant = item
                console.log(this.visiteCourant.tache)
            },
            handleSelectionChange(val) {
              this.multipleSelection = val;
              console.log(this.multipleSelection)
            },
            submitRapport () {
              // this.loading = true
              if (this.multipleSelection != '' && this.rapportField != '') {
                var form = document.getElementById('formRapport')
                var data = new FormData(form)
                let url = this.domaine + 'visitechantier/'+ this.visiteCourant.id +'/rapport/add'

                // data.append('test[]', this.multipleSelection)
                this.multipleSelection.forEach(function(item){
                  // data.append('option[id][]', item.idTache)
                  data.append('arr[]', item.idTache);
                });

                this.$http.post(url, data).then(response => {
                  if (response.body) {
                    let verif = response.body
                    console.log(verif)
                    if (verif.code === 1) {
                      this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: 'Rapport de visite enregistré avec succès.',
                        type: 'success',
                        position: 'top-center'
                      })
                      this.loadVisiteChantier()
                      this.loading = false
                      this.dialogRapportValid = false
                      this.multipleSelection = ''
                    } else if (verif.code === 0) {
                      this.$message.error(verif.message)
                      this.loading = false
                      this.dialogRapportValid = false
                    }
                  } else {
                    this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                    this.loading = false
                    this.dialogRapportValid = false
                  }
                },
                response => {
                  this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                  this.loading = false
                })
              } else {
                this.$message.error('Veuillez selectionner les taches concernees / le champs description')
                this.$notify.error({
                  title: "ERREUR D'ENREGISTREMENT",
                  message: "Le rapport de visite n'a pas été enregistré.",
                  position: 'top-center'
                })
                this.loading = false
              }
            },
            modalDeleteVisite(ligne){
              this.visiteCourant = ligne
              this.dialogSupVisite = true
            },
            deleteVisite (ligne) {
              this.loading = true
              let url = this.domaine + 'visitechantier/delete/'+ this.visiteCourant.id
              this.$http.get(url).then(response => {
                if (response.body) {
                  this.$notify({
                    title: 'SUPPRESSION',
                    message: response.body.message,
                    type: 'success',
                    position: 'top-center'
                  })
                  this.loadVisiteChantier()
                  this.dialogSupVisite = false
                  this.loading = false
                }
              })
            },
            imprimeListeVisite (type) {
                let url = ""
                if(type == "PDF"){
                    url = this.domaine+"visitechantier/imprimerPDF/liste"
                }else {
                    url = this.domaine+"visitechantier/imprimerEXC/liste"
                }
                window.open(url)
            },
            imprimerVisiteChantier (ligne) {
                let url = this.domaine+"visitechantier/imprimerPDF/"+ ligne.id +"/visite"
                window.open(url)
            },
            toggleSelection(rows) {
              if (rows) {
                rows.forEach(row => {
                  this.$refs.multipleTable.toggleRowSelection(row);
                });
              } else {
                this.$refs.multipleTable.clearSelection();
              }
            },
            handleSelectionChange(val) {
              this.multipleSelection = val;
            },

        },
        computed: {
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Chantier.vue